import { render } from "./AyudaInteraccionMed.vue?vue&type=template&id=ebc88ff4&scoped=true"
import script from "./AyudaInteraccionMed.vue?vue&type=script&lang=js"
export * from "./AyudaInteraccionMed.vue?vue&type=script&lang=js"

import "@/assets/css/ayuda.css?vue&type=style&index=0&id=ebc88ff4&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebc88ff4"]])

export default __exports__